import { fg } from '@atlassian/jira-feature-gating';

const isLinkedIssuesPaginationEnabled = {
	get(): boolean {
		return fg('jira_linked_issues_pagination');
	},
};

export default isLinkedIssuesPaginationEnabled;
